import React from "react";

import { CycleGuests, cycleGuestPortraits } from "../CycleGuests";
import { trimestres } from "../../../utils/copy";

export function Percurso() {
  return (
    <section id="percurso" aria-labelledby="percurso-titulo" className="cycles-section">
      <h2 id="percurso-titulo" className="sr-only">O percurso em quatro ciclos</h2>

      {trimestres.map((ciclo, index) => {
        const cycleNum = (index + 1) as 1 | 2 | 3 | 4;
        const { foto, real } = cycleGuestPortraits[cycleNum];

        return (
        <div key={ciclo.id} className={`poster-bleed poster-bleed-cycle-${index + 1}`}>
          <article id={ciclo.id} data-bg={index === 1 ? "#f0eadb" : index === 3 ? "#e8c4c5" : index === 2 ? "#2c171e" : "#0b0b0c"} className={`poster-section cycle cycle-${index + 1}`}>
          <span aria-hidden="true" className="cycle-ghost-number">{ciclo.numero.padStart(2, "0")}</span>

          <div className="cycle-copy">
            {/* a janela do ciclo (set/2026 → nov/2026) sai dos próprios meses:
                é o "quando" que o card da Manuela traz ao lado do rótulo */}
            <p className="cycle-kicker">
              <span>Ciclo <b>{ciclo.numero.padStart(2, "0")}</b> / 04</span>
              <i>{ciclo.meses[0].data} → {ciclo.meses[2].data}</i>
            </p>
            {/* faixa da convidada: só mobile (polaroid some lá). Desktop
                fica só com a polaroid lateral. */}
            <figure className="cycle-guest-strip">
              <span className="cycle-guest-strip-photo">
                <img
                  src={foto}
                  alt={real ? `${ciclo.convidadas}, convidada do ciclo` : ""}
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </span>
              <figcaption className="cycle-guest-strip-name">
                {real ? ciclo.convidadas : "Nome pendente"}
              </figcaption>
            </figure>
            <h3 data-motion="title" className="type-compressed">
              {index === 2 ? <><span>Trabalho</span><span>e dinheiro</span></> : ciclo.titulo}
            </h3>
            {/* as frases "A gente aprendeu…" saíram no ajuste jul/2026; fica só
                o "vamos estudar", que diz o que o ciclo entrega */}
            <p data-motion="lead" className="cycle-estudo">{ciclo.estudo}</p>

            <ol data-motion-list className="cycle-timeline">
              {ciclo.meses.map((mes, mesIndex) => (
                <li key={mes.nome}>
                  <span aria-hidden="true" className="cycle-node">{String(mesIndex + 1).padStart(2, "0")}</span>
                  <strong>{mes.data}</strong>
                  <span className="cycle-mes">{mes.nome}</span>
                  <small className="type-voice">{mes.sub}</small>
                </li>
              ))}
            </ol>
            <p className="type-voice cycle-guest-note">+ conversa ao vivo com convidada</p>
          </div>

          <CycleGuests cycle={cycleNum} />
          </article>
        </div>
        );
      })}
    </section>
  );
}
